<div class="container" *ngIf="hasFeatureAccess">
    <div class="top">
        <h6>{{ 'GenerateSchedule' | translate: {Default: "Generate Schedule"} }}</h6>
    </div>

    <div class="main-container">
        <div class="page-description-section">
            {{ 'GeneratePositionScheduleDescriptionMsg' | translate: {Default: "Select a date range you wish to generate the schedule for."} }}
        </div>

        <div class="form-container">
            <app-form-generator
                [formId]="formId"
                [formData]="formData"
                [emitFormDataTrigger]="getFormData"
                (emitFormData)="formDataEmitted($event)"
                (emitFormStatus)="formStatusUpdated($event)"
                (emitFormPristine)="formPristineEmitted($event)"
            ></app-form-generator>

            <button 
                mat-flat-button 
                setColor="primaryColour" 
                color="primary" 
                appPreventDoubleClick 
                (throttledClick)="getFormData = !getFormData" 
                [disabled]="!formValid"
            >
                <mat-icon aria-hidden="false" class="material-icons-outlined" aria-label="add icon">play_circle_outline</mat-icon> 
                {{ 'GenerateSchedule' | translate: {Default: "Generate Schedule"} }}
            </button>
        </div>
    </div>
</div>